/**
 *  Initialize Sub-Nav
 */

var subNav = (function () {
    var pub = {}; // public facing functions

    pub.init = function () {
        var $body = $('body');
        var $subNav = $('.sub-nav');
        var $toggle = $('.sub-nav__toggle');

        $toggle.click(function () {
            $body.toggleClass('no-scroll');
            $body.toggleClass('sub-nav-expanded');
            $subNav.toggleClass('is-expanded');
        });

        // Set .active on subnav links with .js-subnav-set-active 
        // that link to the same page and are not anchors (#)
        $(function () {
            var current = location.pathname;
            $('.js-subnav-set-active').each(function () {
                // if theres a match, add .is-active to parent li
                if ($(this).attr('href').indexOf(current) !== -1) {
                    $(this).parent('li').addClass('is-active');
                }
            })
        })

        $('a.sub-nav__link.btn').click(function () {
            if (/^#/.test($(this).attr('href')) && $subNav.hasClass('is-expanded')) {
                $toggle.trigger('click');
            }
        });

        $(document).on('click', 'li.sub-nav__item.is-active', function (e) {
            if (window.matchMedia('(max-width: 767px)').matches) {
                e.preventDefault();
                $toggle.trigger('click');
            } else {
                e.preventDefault();
            }
        });
    };

    return pub;
})();